/***************************************** Mini Cart *****************************/

// subscription benefits
const benefits = ["Easy to edit, skip", "Fast & free shipping", "Cancel anytime"]

// flatten selling plans across all selling_plan_groups (each frequency is its own group now)
function flattenSellingPlans(product) {
    if (!product || !product.selling_plan_groups) {
        return [];
    }
    return product.selling_plan_groups.flatMap(group => group.selling_plans || []);
}

// strip "Delivery every " prefix from a selling plan name
function planFrequencyLabel(planName) {
    if (!planName) {
        return "";
    }
    return planName.replace("Delivery every ", "");
}

// flag for user opening cart with items in it, used to determine whether to auto close empty cart or not
let openWithItems = false;

// open cart
async function openCart(skipFetch = false) {

    // open cart
    if (document.querySelector("#miniCart:not([open])")) {
        document.querySelector("#miniCart").showModal();
    }

    document.querySelector('#miniCart').classList.add('active');
    document.querySelector("body").classList.add("noScroll");


    // fetch cart
    if (skipFetch === false) {
        cart = await fetch("/cart.js")
            .then(function (data) {
                return data.json();
            });
    }
    // start loading on the cart
    document.querySelector("#miniCartContentWrapper").classList.add("loading");

    // hide all sections
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartHeaderTitle").classList.remove("active");
    document.querySelector("#miniCartContent").classList.remove("active");
    document.querySelector('#miniCartUpsells').classList.remove('active');

    // stop loading on the cart
    document.querySelector("#miniCartContentWrapper").classList.remove("loading");

    //  update cart count in header nav and mini cart header
    document.querySelector('#headerBodyIconsCart').setAttribute("data-count", cart.item_count);
    document.querySelector("#miniCartHeaderTitle").textContent = `Cart ( ${cart.item_count} )`;

    // check for empty cart and EXIT
    if (cart.item_count === 0) {
        // animate empty state
        document.querySelector("#miniCartEmpty").classList.add("active");

        // clear any discount codes
        await updateCart({discount: ""});

        // close the cart automatically if it's open after 3 seconds if the user opened the cart with items in it
        if (openWithItems === true) {
            setTimeout(async () => {
                // set the flag back to false
                openWithItems = false;

                // check if user has closed the cart already, if so, exit
                if (!document.querySelector("#miniCart").classList.contains("active")) {
                    return;
                }
                document.querySelector("#miniCart").classList.remove("active");
                // after we remove active, close the cart after a half second sleep
                await sleep(500);
                closeCart();

            }, 1500);
        }
        return;

    }


    // set flag for user opening cart with items in it
    openWithItems = true;

    // check how many subscription items are in the cart, including quantity
    let subscriptionItems = 0;
    cart.items.forEach(item => {
        if (item.selling_plan_allocation) {
            subscriptionItems += item.quantity;
        }
    });

    // if there's no applied discount code and we need to clean up, run the cleanup function
    if (document.querySelector('#miniCartFooterDiscount')) {
        if (!cart.cart_level_discount_applications.length > 0) {
            cleanUpDiscountCode();
        } else {
            // if there is an applied discount code, make sure the discount code section is showing
            document.querySelector('#miniCartFooterDiscountCodeWrap').classList.add('active');

            // if the discount code section is empty, add in the discount code info
            if (document.querySelector('#miniCartFooterDiscountCodeWrap').innerHTML === "") {
                document.querySelector('#miniCartFooterDiscountCodeWrap').insertAdjacentHTML("beforeend",
                    ` <div class="miniCartFooterDiscountCode">
                        <span class="miniCartFooterDiscountCodeTitle">${cart.cart_level_discount_applications[0].title} discount</span>
                        <span class="miniCartFooterDiscountCodePrice">-${price(cart.original_total_price - cart.total_price)}</span>
                    </div>`);
            }
        }
    }

    // show main cart sections
    document.querySelector("#miniCartContent").classList.add("active");
    document.querySelector("#miniCartHeaderTitle").classList.add("active");

    // reset body container
    document.querySelectorAll(".miniCartBodyItem").forEach(element => element.remove());

    // update subtotal-- (including any discounts)
    document.querySelector("#miniCartFooterPrice span").textContent = price(cart.total_price, true);

    // update the total savings

    let totalSavings = 0;
    let yearlySavings = 0;

    cart.items.forEach(item => {
        // check if item has a selling plan allocation
        if (item.selling_plan_allocation) {
            let comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;

            // determine the delivery cadence (in WEEKS)
            let cadence = parseInt((item.selling_plan_allocation.selling_plan.options[0].value).match(/\d+/g)[0]);

            // determine how many times per year deliveries can be made based on cadence
            let yearlyDeliveries = Math.floor((52 / cadence));

            if (comparePrice) {
                let savings = comparePrice - item.final_line_price;
                if (savings > 0) {
                    yearlySavings += (savings * yearlyDeliveries);
                    totalSavings += savings;
                }
            }
        }
    })

    // total savings per each delivery
    document.querySelector('.miniCartFooterSaveInfoPer').textContent = `-${price(totalSavings, true)}`;

    // any subscriptions? if so, free shipping
    let shippingMessage = document.querySelector("#miniCartFooterShipping");
    if (subscriptionItems > 0) {
        // if the free shipping message isn't already active, add active
        if (!shippingMessage.classList.contains('active')) {
            shippingMessage.classList.add('active')
        }
        // hide the $0 saved message
        document.querySelector('#miniCartFooterSave').classList.remove('active');

        // update color of subtotal price to sub blue color
        document.querySelector('#miniCartFooterPrice').classList.add('active');
    } else {
        // remove the free shipping message
        shippingMessage.classList.remove('active')
        document.querySelector('#miniCartFooterPrice').classList.remove('active');

        // show the $0 saved message
        document.querySelector('#miniCartFooterSave').classList.add('active');

        // remove sub blue color from subtotal price
        document.querySelector('#miniCartFooterPrice').classList.remove('active');
    }

    // append cart
    cart.items.forEach(function (item) {
        // variant HTML
        function variantHTML() {
            // check for default variant
            if (item.variant_title === null) {
                return "";
            }

            return `<div class="miniCartBodyItemVariant">${item.variant_title}</div>`;
        }

        // subscription HTML
        function subscriptionHTML() {
            if (item.selling_plan_allocation) {
                return `<div class="miniCartBodyItemSellingPlan">${item.selling_plan_allocation.selling_plan.name}</div>`;
            }
            return "";
        }

        // subscription HTML
        function purchaseType() {
            let comparePrice = null;
            let HTML = "One-time purchase";
            if (item.selling_plan_allocation) {
                //  append compare_at_price * quantity
                comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
                // check for savings
                if (comparePrice) {
                    let savings = comparePrice - item.final_line_price;
                    if (savings > 0) {
                        HTML = `<span>${price(savings, false)} Subscription Discount</span>`;
                    }
                }
                return `<div class="miniCartBodyItemType subscription">${HTML}</div>`;
            } else {
                return `<div class="miniCartBodyItemType">${HTML}</div>`;
            }
        }

        function upsellTitle() {
            // first check if this is an upsell item and it's not replacing in cart
            if (!Object.values(upsellMatrix).find(upsell => variantIDToProduct[item.variant_id]?.handle === upsell.handle)
                || (Object.values(upsellMatrix).find(upsell => variantIDToProduct[item.variant_id]?.handle === upsell.handle)?.replace_in_cart === false)) {
                return "";
            }

            // get the handle of the upsell
            const upsellProduct = variantIDToProduct[item.variant_id];
            // find the upsell in the matrix
            const productEntry = Object.entries(upsellMatrix).find(([, upsell]) => upsellProduct.handle === upsell.handle) || [];

            // get the product title
            let itemTitle = variantIDToProduct[handleToVariantID[productEntry[0]]].title.replace("PlantPaper - ", "").replace("Rolls", "rolls PlantPaper");

            return `<div class="miniCartBodyItemLabel">${itemTitle}</div>`;
        }

        // protectionVariantIDice HTML
        function priceHTML() {
            let HTML = "";

            /****************** discount ******************/

            let comparePrice = null

            // check if this product is an upsell product that replaces an item in the cart
            let originalEntry = null;
            originalEntry = Object.entries(upsellMatrix).find(([, upsell]) => variantIDToProduct[item.variant_id]?.handle === upsell.handle && upsell.replace_in_cart === true);

            // if we find the original product that was replaced, use its original and compare at price
            if (originalEntry != null) {
                if (variantIDToProduct[handleToVariantID[originalEntry[0]]]) {
                    let originalProduct = variantIDToProduct[handleToVariantID[originalEntry[0]]];
                    let originalSub = null;
                    let realPrice = originalProduct.variants[0].price * item.quantity;
                    let comparePrice = originalProduct.variants[0].price * item.quantity;

                    // try to find the original subscription plan allocation if it exists
                    if (item.selling_plan_allocation) {
                        let currentPlan = item.selling_plan_allocation.selling_plan.name;
                        let plans = flattenSellingPlans(originalProduct);

                        // more than one selling plan? try to match it to the original cadence
                        if (plans.length > 1) {
                            originalSub = plans[0];
                            for (const plan of plans) {
                                if (plan.name === currentPlan) {
                                    originalSub = plan;
                                    break;
                                }
                            }
                        }
                        // determine the subscription discount based on the original subscription plan if it exists
                        if (originalSub != null) {
                            realPrice = (originalProduct.variants[0].price * (1 - (originalSub.price_adjustments[0].value / 100))) * item.quantity;
                        }
                    }
                    // check if compare price
                    if (comparePrice > realPrice) {
                        HTML += `<s>${price(comparePrice, false)}</s>`;
                    }


                    HTML += `<span class="${isSubscription()}">${price(realPrice, false)}</span>`;

                }
            } else {

                // check for compare at price
                if (variantIDToProduct[item.variant_id] && variantIDToProduct[item.variant_id]?.compare_at_price) {
                    comparePrice = variantIDToProduct[item.variant_id].compare_at_price * item.quantity;
                }
                // check if selling_plan_allocation exists, if so append compare_at_price * quantity
                else if (item.selling_plan_allocation) {
                    comparePrice = item.selling_plan_allocation.compare_at_price * item.quantity;
                }
                // check for line item discount
                else if (item.original_line_price > item.final_line_price) {
                    comparePrice = item.original_line_price;
                }
                // check if comparePrice exists
                if (comparePrice) {
                    HTML += `<s>${price(comparePrice, false)}</s>`;
                }

                HTML += `<span class="${isSubscription()}">${price(item.final_line_price, false)}</span>`;
            }

            return HTML;
        }

        // check if item is subscription
        function isSubscription() {
            if (item.selling_plan_allocation) {
                return 'subscription'
            }
            return "";
        }

        function frequencyOptions() {

            let HTML = ""
            if (item.selling_plan_allocation) {
                let frequencyName = planFrequencyLabel(item.selling_plan_allocation.selling_plan.name);

                HTML +=
                    `<div class="miniCartBodyItemFrequencySelectOptions">
            <div class="miniCartBodyItemFrequencySelectOptionsSelected" data-selling_plan="${item.selling_plan_allocation.selling_plan.id}">
                        <span>Delivered every<u class="editFrequency">${frequencyName}</u></span>
                    </div>
                    <button class="miniCartBodyItemFrequencySelectOptionsEdit">
                    Edit
                    </button>
</div>`
            }
            return HTML;
        }

        // upgrade to subscription HTML
        function upgradeHTML() {
            // // check if it's already a subscription
            // if (item.selling_plan_allocation) {
            //     return "";
            // }

            // get the selling plan id for this variant if it exists
            let sellingPlanID;
            let sellingPlanName;

            // get the selling plans off the product
            let sellingPlans = flattenSellingPlans(variantIDToProduct[item.variant_id]);

            // check if default cadence matrix has an entry for this product, and if so, make that the default
            let hasDefault = false;
            let defaultPlan = null;

            if (sellingPlans) {
                sellingPlans.forEach((sellingPlan) => {
                    if (sellingPlan.name.includes(defaultCadenceMatrix[item.handle])) {
                        hasDefault = true;
                        defaultPlan = sellingPlan;
                    }
                })
            }

            // check for selling plan on the variant
            if (item.selling_plan_allocation) {
                sellingPlanID = item.selling_plan_allocation.selling_plan.id;
                // check if this plan is the default cadence for this product, and if so, add "Most Popular"
                if (hasDefault && sellingPlanID === defaultPlan.id) {
                    sellingPlanName = planFrequencyLabel(item.selling_plan_allocation.selling_plan.name) + " (Most Popular)";
                } else {
                    sellingPlanName = planFrequencyLabel(item.selling_plan_allocation.selling_plan.name);
                }
            }
            // check if there was an original selling plan before the item was updated
            else if (item.properties._originalPlan) {
                sellingPlanID = item.properties._originalPlan;
                let plan = flattenSellingPlans(variantIDToProduct[item.variant_id]).find(plan => plan.id === sellingPlanID);

                // check if this the default cadence for this product, and if so, add "Most Popular"
                if (hasDefault && sellingPlanID === defaultPlan.id) {
                    sellingPlanName = planFrequencyLabel(plan.name) + " (Most Popular)";
                } else {
                    sellingPlanName = planFrequencyLabel(plan.name);
                }
            }
            // check if this item has a default cadence selling plan from the matrix, and if a plan exists for that plan
            else if (hasDefault) {
                sellingPlanID = defaultPlan.id;
                sellingPlanName = planFrequencyLabel(defaultPlan.name) + " (Most Popular)";
            } else
                // if not, check for any selling plan on the variant
            {
                sellingPlanID = variantIDToSellingPlanID[item.variant_id];
                sellingPlanName = planFrequencyLabel(variantIDToSellingPlan[item.variant_id]?.name);
            }
            // or exit if no selling plan id
            if (!sellingPlanID) {
                return "";
            }

            // determine the total with subscription items only, and apply the discount amount to that
            const subscriptionTotal = cart.items
                .filter(item => item.selling_plan_allocation)
                .reduce((sum, item) => sum + item.final_line_price, 0);

            // get the rest of the information off the product
            let planInfo = flattenSellingPlans(variantIDToProduct[item.variant_id]).find(plan => plan.id === sellingPlanID);

            // get the pricing adjustments from the subscription plan
            let adjustedPricing = planInfo.price_adjustments[0].value / 100;

            // determine the delivery cadence
            let cadence = parseInt((planInfo.name).match(/\d+/g)[0]);

            // yearly savings
            let yearlySavings = 0;

            // how deliveries per year?
            let yearlyDeliveries = Math.floor(52 / cadence);
            yearlySavings = (Math.ceil(adjustedPricing * (item.final_line_price / 100)) * 100) * yearlyDeliveries;

            // list out the benefits of subscribing, including the savings
            let HTML = "";
            HTML += `<div class="miniCartBodyItemUpgradeContentBenefitsItem">
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.924 0.042547C11.2972 0.25577 10.3393 0.892708 9.2896 1.79417C8.06826 2.84313 5.5917 5.29682 4.49919 6.54041L4.25765 6.81545L3.30814 6.38241C1.3986 5.51147 0.407267 5.37763 0.0953457 5.94866C-0.0933879 6.29406 -0.03562 6.41816 0.577309 6.98479C1.71053 8.03238 2.54593 9.07611 3.67307 10.8527C4.08453 11.5011 4.4243 11.974 4.48727 11.9858C4.79531 12.0431 4.86782 11.9599 5.2419 11.1209C5.70793 10.0756 6.7093 8.18854 7.276 7.28768C8.55712 5.25116 10.0666 3.45026 11.8101 1.87843C12.9546 0.846631 13.101 0.640355 12.9513 0.27103C12.8662 0.0611321 12.2634 -0.0729413 11.924 0.042547Z" fill="#153BFE"/>
                </svg>
                Save ${price(yearlySavings, true)} per year</div>`;

            // each of the benefits, added as an item
            benefits.forEach(benefit => {
                HTML += `<div class="miniCartBodyItemUpgradeContentBenefitsItem">  
                <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M11.924 0.042547C11.2972 0.25577 10.3393 0.892708 9.2896 1.79417C8.06826 2.84313 5.5917 5.29682 4.49919 6.54041L4.25765 6.81545L3.30814 6.38241C1.3986 5.51147 0.407267 5.37763 0.0953457 5.94866C-0.0933879 6.29406 -0.03562 6.41816 0.577309 6.98479C1.71053 8.03238 2.54593 9.07611 3.67307 10.8527C4.08453 11.5011 4.4243 11.974 4.48727 11.9858C4.79531 12.0431 4.86782 11.9599 5.2419 11.1209C5.70793 10.0756 6.7093 8.18854 7.276 7.28768C8.55712 5.25116 10.0666 3.45026 11.8101 1.87843C12.9546 0.846631 13.101 0.640355 12.9513 0.27103C12.8662 0.0611321 12.2634 -0.0729413 11.924 0.042547Z" fill="#153BFE"/>
                </svg>
                ${benefit}</div>`;
            })

            // get all of the selling plans off the product
            let plansHTML = "";

            // add all of the selling plans as options
            sellingPlans.forEach(plan => {
                // make sure we're not adding the currently selected plan again
                if (plan.id !== sellingPlanID) {
                    let frequency = planFrequencyLabel(plan.name);

                    // if this plan is the default cadence for this product, add "Most Popular" to the end of the frequency name
                    if (defaultPlan && plan.id === defaultPlan.id) {
                        frequency += " (Most Popular)";
                    }

                    plansHTML += `
            <div class="miniCartBodyItemUpgradeContentFrequencySelectOption miniCartBodyItemUpgradeContentFrequencySelectRow"
                 selling_plan="${plan.id}">
                <span>${frequency}</span>
           
            </div>
            `;
                }
            })

            // return HTML
            return `
        <div class="miniCartBodyItemUpgrade">
        <div class="miniCartBodyItemUpgradeWrapper">
                <div 
                    class="miniCartBodyItemUpgradeContent">
                <div class="miniCartBodyItemUpgradeContentTop">
                <div class="miniCartBodyItemUpgradeContentToggle" 
                     data-key="${item.key}"
                     data-id="${item.variant_id}"
                     data-quantity="${item.quantity}" 
                     data-plan="${sellingPlanID}">
                    <label class="miniCartBodyItemUpgradeContentToggleInner">
                        <input type="checkbox" ${isSubscription() === 'subscription' ? 'checked' : ''} />
                        <span class="miniCartBodyItemUpgradeContentToggleInnerSwitch"></span>
                    </label>
                    Subscribe & Save
                    </div>
                    <div class="miniCartBodyItemUpgradeContentPacks">${productPacks()}</div>
                    <button class="miniCartBodyItemUpgradeContentRemove">
                        <svg width="17" height="19" viewBox="0 0 17 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6.67875 0.0619176C6.35879 0.151113 6.06571 0.334773 5.79779 0.613973C5.36949 1.06036 5.20916 1.51717 5.20798 2.29437L5.20737 2.71178H2.85657C0.534158 2.71178 0.50388 2.71274 0.348947 2.79047C0.116495 2.90712 0 3.11 0 3.39818C0 3.68636 0.116495 3.88924 0.348947 4.00589C0.481154 4.07223 0.570985 4.08459 0.921722 4.08459H1.3377L1.35749 4.24228C1.36834 4.32902 1.65093 7.54723 1.98546 11.3939C2.31998 15.2405 2.60998 18.4482 2.62999 18.5219C2.67891 18.7027 2.78796 18.8387 2.9546 18.9268C3.09049 18.9987 3.18906 19 8.5 19C13.8109 19 13.9095 18.9987 14.0454 18.9268C14.212 18.8387 14.3211 18.7027 14.37 18.5219C14.39 18.4482 14.68 15.2405 15.0145 11.3939C15.3491 7.54723 15.6317 4.32902 15.6425 4.24228L15.6623 4.08459H16.0783C16.429 4.08459 16.5188 4.07223 16.6511 4.00589C16.8835 3.88924 17 3.68636 17 3.39818C17 3.11 16.8835 2.90712 16.6511 2.79047C16.4961 2.71274 16.4658 2.71178 14.1434 2.71178H11.7926L11.792 2.29437C11.7908 1.51717 11.6305 1.06036 11.2022 0.613973C10.9285 0.328762 10.6395 0.150149 10.3059 0.0600624C10.0054 -0.0210818 6.97089 -0.0195606 6.67875 0.0619176ZM10.156 1.48675C10.3842 1.64892 10.4326 1.78784 10.4326 2.28086V2.71178H8.5H6.56737L6.56751 2.27582C6.56762 1.89692 6.57757 1.82294 6.6436 1.71066C6.73075 1.56244 6.7922 1.505 6.94316 1.43065C7.03167 1.38701 7.31183 1.37922 8.53847 1.38616L10.0264 1.39462L10.156 1.48675ZM14.2979 4.16807C14.298 4.2852 13.1557 17.3591 13.1326 17.5066L13.1136 17.6272H8.5H3.88642L3.8673 17.5066C3.84486 17.3649 2.70211 4.27808 2.70211 4.16284V4.08459H8.5H14.2979L14.2979 4.16807ZM4.92707 5.49781C4.75302 5.58949 4.60593 5.79218 4.57636 5.98107C4.56552 6.05034 4.70453 8.26914 4.88526 10.9117C5.2049 15.5849 5.21628 15.7217 5.30182 15.9092C5.5338 16.418 6.22894 16.4196 6.48223 15.9118C6.51537 15.8454 6.53609 15.7064 6.53537 15.5555C6.53473 15.4195 6.38849 13.1993 6.2104 10.6217C5.91851 6.39696 5.87953 5.92082 5.81472 5.7891C5.65764 5.46998 5.24008 5.33292 4.92707 5.49781ZM8.23011 5.49005C8.06756 5.56656 7.90504 5.74729 7.86474 5.89622C7.82934 6.02708 7.82984 15.6866 7.86524 15.8177C7.90314 15.9581 8.09987 16.1812 8.23881 16.2414C8.3868 16.3054 8.6132 16.3054 8.76119 16.2414C8.90013 16.1812 9.09686 15.9581 9.13476 15.8177C9.17016 15.6866 9.17066 6.02708 9.13526 5.89622C9.06952 5.65316 8.7598 5.42193 8.5 5.42193C8.43111 5.42193 8.30964 5.45258 8.23011 5.49005ZM11.5473 5.45799C11.3855 5.52905 11.2536 5.65026 11.1838 5.79218C11.121 5.91985 11.0786 6.43874 10.7896 10.6217C10.6115 13.1993 10.4653 15.4195 10.4646 15.5555C10.4639 15.7064 10.4846 15.8454 10.5178 15.9118C10.7711 16.4195 11.4661 16.418 11.6983 15.9092C11.7839 15.7215 11.7951 15.587 12.1184 10.8545L12.4506 5.99261L12.3678 5.8153C12.2591 5.58259 12.0663 5.44861 11.8173 5.43276C11.7151 5.42627 11.5936 5.43762 11.5473 5.45799Z" fill="#686868"/>
                        </svg>
                    </button>
                </div>
                <div class="miniCartBodyItemUpgradeContentBottom">
                <div class="miniCartBodyItemUpgradeContentBenefits">
                    ${HTML}
                </div>
                
                ${isCustomer === 'false' ?
                `<div class="miniCartBodyItemUpgradeContentDiscount">
                        Use code: <u><span class="bold">Welcome20</span></u> at checkout for an additional <u><span class="bold">${price(((item.final_line_price - (Math.ceil(adjustedPricing * (item.final_line_price / 100))) * 100) * 0.2), true)}</span></u> off your first order
                    </div>`
                : ""}
                <div class="miniCartBodyItemUpgradeContentFrequency" selling-plan="${sellingPlanID}">
                    <div class="miniCartBodyItemUpgradeContentFrequencyTitle">Delivered every:</div>
                        <div class="miniCartBodyItemUpgradeContentFrequencySelect">
                            <div class="miniCartBodyItemUpgradeContentFrequencySelectLabel miniCartBodyItemUpgradeContentFrequencySelectRow">
                            ${sellingPlanName}
                            </div>
                            <div class="miniCartBodyItemUpgradeContentFrequencySelectOptions">
                               ${plansHTML}
                            </div>
                        </div>
                </div>
        </div>
                </div>
                </div>
        </div>
            `;
        }

        // get the other pack sizes for the product
        function productPacks() {

            // if this is a 12 boxes of tissue product, hide the pack options
            if (item.handle.includes('12-boxes')) {
                return "";
            }

            // define preselected pack
            let defaultSelection = null;

            // define main handles object
            let mainHandles = {};
            
            // determine if this the USA or CA store
            if (isCanada === true) {
                // add in only the handles for the CA store
                for (const [key, value] of Object.entries(handleToVariantID)) {
                    if (key.toString().includes('-ca')) {
                        mainHandles[key] = value;
                    }
                }
            } else {
                // add in only the handles for the US store
                for (const [key, value] of Object.entries(handleToVariantID)) {
                    if (!key.toString().includes('-ca')) {
                        mainHandles[key] = value;
                    }
                }
            }

            // determine the preselected pack
            for (const [key, value] of Object.entries(mainHandles)) {
                if (parseInt(value) === parseInt(item.variant_id)) {
                    defaultSelection = [key, value];
                }
            }

            // format title for default handle (not pretty)
            let defaultTitle = '';
            if (defaultSelection != null) {
                if (defaultSelection[0].includes('boxes')) {
                    defaultTitle = defaultSelection[0].replace('-', ' ').replace('rolls', ' +').replace('-', ' ').replace('-boxes', '').replace('-ca', '').replace('ca', '');
                } else {
                    defaultTitle = defaultSelection[0].replace('-', ' ').replace('-', ' ').replace('-boxes', ' tissue').replace('-ca', '').replace('ca', '');
                }
            }


            // set it up with the default main handle if not null
            let HTML = `
                <div class="miniCartBodyItemUpgradeContentPacksItemDefault" data-id="${defaultSelection[1]}">
                    ${defaultTitle}
                </div>
                `

            let packsHTML = "";

            // if this is an upsell item replacing in cart, remove the other packs that aren't also replace in cart upsells
            if (Object.values(upsellMatrix).find(upsell => variantIDToProduct[item.variant_id]?.handle === upsell.handle)?.replace_in_cart === true) {
                // filter mainHandles to only include items that replace in cart
                for (const [key, value] of Object.entries(mainHandles)) {
                    if (!(Object.values(upsellMatrix).find(upsell => variantIDToProduct[value]?.handle === upsell.handle)?.replace_in_cart === true)) {
                        delete mainHandles[key];
                    }
                }
            }
            // if this isn't an upsell item in general, remove the upsell items from the pack options
            else {
                // filter mainHandles to only include non-upsell items
                for (const [key, value] of Object.entries(mainHandles)) {
                    if (Object.values(upsellMatrix).find(upsell => variantIDToProduct[value]?.handle === upsell.handle)) {
                        delete mainHandles[key];
                    }
                }
            }

            // also make sure to remove default selection from the pack options
            if (defaultSelection != null) {
                for (const [key, value] of Object.entries(mainHandles)) {
                    if (parseInt(value) === parseInt(item.variant_id)) {
                        delete mainHandles[key];
                    }
                }
            }

            // get the main handles for the product packs
            for (const [key, value] of Object.entries(mainHandles)) {
                // only add the pack if it's not the default/selected one
                if (parseInt(value) === defaultSelection[1]) {
                    continue;
                }

                let itemTitle = '';

                if (key.includes('boxes')) {
                    itemTitle = key.replace('-', ' ').replace('rolls', ' +').replace('-', ' ').replace('-boxes', '').replace('-ca', '').replace('ca', '');
                } else {
                    itemTitle = key.replace('-', ' ').replace('-', ' ').replace('-boxes', ' tissue').replace('-ca', '').replace('ca', '');
                }
                packsHTML += `<div class="miniCartBodyItemUpgradeContentPacksContainerItem" data-id="${value}">
                        ${itemTitle}    
                    </div>`
            }

            // add option to remove the upsell item if it's a pack that's replacing in cart
            if (Object.values(upsellMatrix).find(upsell => variantIDToProduct[item.variant_id]?.handle === upsell.handle)?.replace_in_cart === true) {
                packsHTML += `<div class="miniCartBodyItemUpgradeContentPacksContainerItem remove" data-id="${item.variant_id}">
                        Remove Tissue    
                    </div>`
            }

            HTML += `<div class="miniCartBodyItemUpgradeContentPacksContainer">
                                        ${packsHTML}
                                    </div>`;
            return HTML;
        }

        function upsellItem() {
            // first check if this is an upsell item
            if (!Object.values(upsellMatrix).find(upsell => variantIDToProduct[item.variant_id]?.handle === upsell.handle)) {
                return "";
            }

            // define html
            let HTML = ""

            // current upsell product
            const upsellProduct = variantIDToProduct[item.variant_id];

            // find the upsell in the matrix
            const matrixEntry = Object.values(upsellMatrix).find(upsell => upsellProduct.handle === upsell.handle)

            // check if we're replacing in cart
            if (!matrixEntry.replace_in_cart) {
                return HTML;
            }
            // product title (not very pretty)
            const upsellTitle = upsellProduct.title.replace("PlantPaper", "").replace("16", "").replace("32", "").replace("96", "").replace("Rolls", "").replace("-", "").replace("+", "").replace("Tissues", "").trim().toLowerCase();

            // get the original product handle
            const productEntry = Object.entries(upsellMatrix).find(([, upsell]) => upsellProduct.handle === upsell.handle) || [];

            let subTitle = "";

            // declare price variables
            let comparePrice = "";
            let realPrice = "";
            let discounted = 'noDiscount';

            // check that the array is not empty
            if (productEntry.length > 0) {
                // get the variantID from the original product we found
                let product = variantIDToProduct[handleToVariantID[productEntry[0]]];

                // update the real price
                // check if we're subscribed
                if (item.selling_plan_allocation) {
                    realPrice = (upsellProduct.variants[0].selling_plan_allocations[0].per_delivery_price - product.variants[0].selling_plan_allocations[0].per_delivery_price)
                } else {
                    realPrice = (upsellProduct.variants[0].price - product.variants[0].price);
                }

                // check if we have special bundle subscription discount
                if (bundlePricing[upsellProduct.handle]) {
                    discounted = 'discount';
                    comparePrice = bundlePricing[upsellProduct.handle] * 100;
                }
                // otherwise, check if the discount from the subscription is greater than the discount from just the price difference, and if so, apply the subscription discount language to the price
                else if (((upsellProduct.variants[0].price - product.variants[0].price) - Math.ceil(realPrice)) > 0) {
                    discounted = 'discount';
                    comparePrice = (upsellProduct.variants[0].price - product.variants[0].price);
                }

                // if we have a compare price
                if (comparePrice !== "")
                    subTitle = `<span class="miniCartBodyItemUpsellWrapperBottomPriceTitle">${price(comparePrice - realPrice)} Bundle Discount</span>`
            }
            HTML += `<div class="miniCartBodyItemUpsell" data-handle="${upsellProduct.handle}">
                         <div class="miniCartBodyItemUpsellWrapper">
                              <div class="miniCartBodyItemUpsellWrapperTop">
                                    <div class="miniCartBodyItemUpsellWrapperTopTitle">
                                       ${upsellTitle} Tissue
                                    </div>
                                    </div>
                                <div class="miniCartBodyItemUpsellWrapperBottomPrice">
                                   ${item.selling_plan_allocation ? subTitle : `<span>One-time purchase</span>`}
                                   <div class="miniCartBodyItemUpsellWrapperBottomPriceWrap">
                                        <div class="miniCartBodyItemUpsellWrapperBottomPriceCompare">
                                        ${comparePrice ? price(comparePrice) : ""}
                                        </div>
                                        <div class="miniCartBodyItemUpsellWrapperBottomPriceReal ${discounted}">
                                            ${price(realPrice)}
                                        </div>
                                    </div>
                                </div>
                         </div>
                    </div>`

            return HTML;
        }


        // get prod title
        let itemTitle = item.product_title;

        // update the format of the title
        if (itemTitle.toLowerCase().includes("plantpaper - ") && !itemTitle.toLowerCase().includes("tissues")) {
            itemTitle = itemTitle.replace("PlantPaper - ", "").replace("Rolls", "rolls") + " PlantPaper"
        } else if (itemTitle.toLowerCase().includes("tissues - ")) {
            let newTitle = itemTitle.replace("PlantPaper Tissues - ", "").replace("Boxes", "");
            itemTitle = newTitle + "boxes Tissue";
        }

        // check if the plan had been edited based on the line item property
        function editedPlan() {
            return !!item.properties?._editedPlan;
        }

        // insert item
        document.querySelector("#miniCartBody").insertAdjacentHTML("afterbegin", `
            <div class="miniCartBodyItem ${isSubscription()} ${editedPlan() === true ? 'edit' : ''}" key="${item.key}" data-id="${item.variant_id}">
                <div class="miniCartBodyItemContent">
                <div class="miniCartBodyItemContentTopWrapper">
                    <div class="miniCartBodyItemContentTop">
                        <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5101 0.0567294C15.6423 0.341027 14.316 1.19028 12.8625 2.39223C11.1714 3.79083 7.74236 7.06243 6.22965 8.72055L5.8952 9.08727L4.58051 8.50988C1.93653 7.34863 0.563909 7.17018 0.132017 7.93155C-0.129306 8.39208 -0.04932 8.55754 0.799352 9.31306C2.36842 10.7098 3.52514 12.1015 5.08578 14.4702C5.6555 15.3348 6.12595 15.9653 6.21315 15.981C6.63966 16.0574 6.74005 15.9466 7.25801 14.8279C7.90328 13.4341 9.2898 10.9181 10.0745 9.7169C11.8483 7.00155 13.9384 4.60034 16.3525 2.50457C17.9371 1.12884 18.1399 0.853807 17.9326 0.361373C17.8147 0.0815094 16.9801 -0.0972551 16.5101 0.0567294Z" fill="#153BFE"/>
                        </svg>
                        <!-- if upsell, show label, otherwise use normal title -->
                         <div class="miniCartBodyItemContentTopTitle">
                                ${upsellTitle() || itemTitle}
                           </div>
                            <div class="miniCartBodyItemContentTopQuantity ${item.quantity >= 2 || editedPlan() === true ? 'active' : ''}">
                                <span class="miniCartBodyItemContentTopQuantityTitle">
                                    QTY.
                                </span>
                                <div class="miniCartBodyItemContentTopQuantityWrapper">
                                    <button class="miniCartBodyItemContentTopQuantityMinus">-</button>
                                    <div class="miniCartBodyItemContentTopQuantityCount">${item.quantity}</div>
                                    <button class="miniCartBodyItemContentTopQuantityPlus">+</button>
                                </div>
                            </div>
                            <div class="miniCartBodyItemContentTopPriceWrapper">
                                ${purchaseType()}
                                <div class="miniCartBodyItemContentTopPrice">
                                    ${priceHTML()}
                                </div>
                            </div>
                            </div>
                            ${upsellItem()}
            </div>
            <div class="miniCartBodyItemContentBottom">
                        ${upgradeHTML()}
                        ${frequencyOptions()}
                    </div>
            </div>
        `);
    });

    // update upsells function
    updateUpsells();

    // event listener for each line item
    document.querySelectorAll(`.miniCartBodyItem`).forEach(function (element) {
        // get key
        let key = element.getAttribute("key");

        // get current quantity
        let quantity = cart.items.find(item => item.key === key)?.quantity;

        // minus
        element.querySelector(".miniCartBodyItemContentTopQuantityMinus").addEventListener("click", function () {
            if (quantity === 1) {
                element.querySelector(".miniCartBodyItemUpgradeContentRemove").click();
            } else {
                quantity--;
                updateCartItem();
            }
        });

        // plus
        element.querySelector(".miniCartBodyItemContentTopQuantityPlus").addEventListener("click", function () {
            quantity++;
            updateCartItem();
        });

        // remove
        element.querySelector(".miniCartBodyItemUpgradeContentRemove").addEventListener("click", function () {
            quantity = 0;
            updateCartItem();
        });

        // update quantity function
        async function updateCartItem() {
            // update label
            element.querySelector(`.miniCartBodyItemContentTopQuantityCount`).textContent = quantity;

            // add loading to cart
            document.querySelector('#miniCartContentWrapper').classList.add("loading");

            // update cart in shopify
            cart = await changeProduct({
                id: key,
                quantity: quantity
            });

            // open cart
            await openCart(true);
        }

        // function to trigger item edit property
        async function triggerItemEdit() {

            // check if item has a selling plan, if not exit
            if (!cart.items.find(item => item.key === key).selling_plan_allocation) {
                return;
            }

            // add loading to cart
            document.querySelector('#miniCartContentWrapper').classList.add("loading");

            // update the selling plan on the item
            cart = await changeProduct({
                id: key,
                quantity: quantity,
                properties: {
                    "_editedPlan": "true"
                }
            });

            // fetch cart
            await openCart(true);
        }

        // function to update item new plan property
        async function updateItemPlan(plan) {

            // check if item has a selling plan, if not exit
            if (!cart.items.find(item => item.key === key).selling_plan_allocation) {
                return;
            }

            // add loading to cart
            document.querySelector('#miniCartContentWrapper').classList.add("loading");

            // get the selected selling plan id
            let sellingPlanID = parseInt(plan);

            // update the selling plan on the item
            cart = await changeProduct({
                id: key,
                quantity: quantity,
                selling_plan: sellingPlanID
            });

            // fetch cart
            await openCart(true);
        }

        // function to update item new variant property
        async function updateVariant(variantID) {
            // add loading to cart
            document.querySelector('#miniCartContentWrapper').classList.add("loading");

            // check if this item had a subscription previously
            let hasSubscription = false;
            let neededPlan = null;
            if (cart.items.find(item => item.key === key)?.selling_plan_allocation) {
                hasSubscription = true;
            }

            // determine if we have a default cadence for this new variant based on the original handle and the matrix
            let sellingPlans = flattenSellingPlans(variantIDToProduct[variantID]);
            let hasDefault = false;
            let defaultPlan = null;
            let variantHandle = variantIDToProduct[variantID]?.handle;

            if (sellingPlans && sellingPlans.length > 0) {
                sellingPlans.forEach((sellingPlan) => {
                    if (sellingPlan.name.includes(defaultCadenceMatrix[variantHandle])) {
                        hasDefault = true;
                        defaultPlan = sellingPlan;
                    }
                })
            }
            // if there is a default cadence for the new variant, use that selling plan ID
            if (hasDefault && defaultPlan != null) {
                neededPlan = defaultPlan.id;
            }
            // otherwise, just use the first selling plan ID available for that variant (if any)
            else if (variantIDToSellingPlanID[variantID]) {
                neededPlan = variantIDToSellingPlanID[variantID];
            }

            // remove this product from the cart
            await changeProduct({
                id: key,
                quantity: 0,
            });

            // add new product to cart
            await addProduct({
                items: [{
                    quantity: quantity,
                    id: variantID,
                    // if there was a selling plan before, attach a selling to this one as well (if applicable)
                    selling_plan: hasSubscription ? neededPlan : null,
                    properties: {
                        "_editedPlan": "true"
                    }
                }]
            });

            // open cart
            await openCart();
        }

        // listen for upgrade button toggle
        element.querySelector(".miniCartBodyItemUpgradeContentToggle")?.addEventListener("click", async function () {

            // get the needed item info for the upgrade
            const key = this.dataset.key;
            const variantID = parseInt(this.dataset.id);
            const sellingPlanID = parseInt(this.dataset.plan);
            const quantity = parseInt(this.dataset.quantity);

            // checkbox
            const checkbox = this.querySelector('.miniCartBodyItemUpgradeContentToggle input[type="checkbox"]');

            // add loading to cart
            document.querySelector('#miniCartContentWrapper').classList.add("loading");

            // create form data object
            let formData = {}

            // if not currently checked and clicked to upgrade to subscription
            if (checkbox.checked === false) {
                // check the box
                checkbox.checked = true;

                // remove this product from the cart
                await changeProduct({
                    id: key,
                    quantity: 0,
                });

                // append data to form object
                formData = {
                    items: [{
                        quantity: quantity,
                        id: variantID,
                        selling_plan: sellingPlanID,
                        properties: {
                            "_editedPlan": "true"
                        }
                    }]
                };

                // add new product to cart
                await addProduct(formData);

                // fetch cart
                await openCart(false);

            } else {
                // uncheck the box
                checkbox.checked = false;

                // remove the selling plan
                await changeProduct({
                    id: key,
                    quantity: quantity,
                    selling_plan: null,
                    properties: {
                        "_originalPlan": sellingPlanID,
                    }
                });

                // fetch cart
                await openCart(false);
            }

        });

        // listen for edit button click
        element.querySelectorAll('.miniCartBodyItemFrequencySelectOptionsEdit, .editFrequency').forEach(button => {
            button?.addEventListener("click", function () {
                triggerItemEdit();
            })
        })

        // listen for frequency or pack select
        element.querySelectorAll('.miniCartBodyItemUpgradeContentFrequencySelect, .miniCartBodyItemUpgradeContentPacksItemDefault').forEach(item => {
            item.addEventListener("click", async function () {
                // toggle active class
                this.classList.toggle('active')
            })
        })

        // listen for frequency change
        element.querySelectorAll(".miniCartBodyItemUpgradeContentFrequencySelectOption").forEach(function (element) {
            element.addEventListener("click", function () {
                let sellingPlanID = parseInt(this.getAttribute("selling_plan"));
                // update the plan data attribute on needed elements
                this.closest('.miniCartBodyItemUpgradeContent').querySelector('.miniCartBodyItemUpgradeContentToggle').dataset.plan = sellingPlanID;

                // update label
                this.parentElement.parentElement.querySelector(".miniCartBodyItemUpgradeContentFrequencySelectLabel").textContent = this.textContent;

                // update the selling plan on the item
                updateItemPlan(sellingPlanID);
            });
        })

        // listen for pack change
        element.querySelectorAll(".miniCartBodyItemUpgradeContentPacksContainerItem:not(.remove)").forEach(async function (element) {
            element.addEventListener("click", function () {
                let variantID = parseInt(this.dataset.id);
                updateVariant(variantID);
            });
        })

        // listen for pack remove (when pack is replacing in cart)
        element.querySelectorAll('.miniCartBodyItemUpgradeContentPacksContainerItem.remove').forEach(button => {
            button.addEventListener('click', async function () {
                // get the key
                const key = element.getAttribute("key");

                // get the product
                const product = cart.items.find(item => item.key === key);

                // get the upsell handle
                let handle = variantIDToProduct[cart.items.find(item => item.key === key).variant_id]?.handle;

                // use the upsell handle with the matrix to find the original product
                let productEntry = Object.entries(upsellMatrix).find(([, upsell]) => handle === upsell.handle) || [];

                if (Array.isArray(productEntry) && productEntry.length > 0) {
                    // get the variantID
                    let variantID = handleToVariantID[productEntry[0]];

                    // add loading to cart
                    document.querySelector('#miniCartContentWrapper').classList.add("loading");

                    // check if the replaced item had a subscription
                    let hadSub = false;
                    let attachedSub = "";
                    const subItem = product.selling_plan_allocation;

                    // if we found the item's subscription plan
                    if (subItem) {
                        hadSub = true;
                        let originalPlan = subItem.selling_plan?.name;
                        let plans = flattenSellingPlans(variantIDToProduct[variantID]);

                        // more than one selling plan? try to match it to the original cadence
                        if (plans.length > 1) {
                            // default to the first plan if we can't find a match
                            attachedSub = plans[0].id;
                            for (const plan of plans) {
                                if (plan.name === originalPlan) {
                                    attachedSub = plan.id;
                                    break;
                                }
                            }
                        }
                    }

                    // remove this product from the cart
                    await changeProduct({
                        id: key,
                        quantity: 0,
                    });

                    // add new product to cart
                    await addProduct({
                        items: [{
                            quantity: product.quantity,
                            id: variantID,
                            selling_plan: hadSub ? attachedSub : null,
                        }]
                    });

                    // open cart
                    await openCart();
                }
            })
        });
    });
}

// close dropdowns when clicking outside
document.querySelector('#miniCart').addEventListener('click', function (e) {
    const activeDropdowns = document.querySelectorAll('.miniCartBodyItemUpgradeContentFrequencySelect, .miniCartBodyItemUpgradeContentPacksItemDefault');
    activeDropdowns.forEach(dropdown => {
        if (!dropdown?.contains(e.target)) {
            dropdown?.classList.remove('active');
        }
    });
});

// close cart function
function closeCart() {
    // hide sections
    document.querySelector("body").classList.remove("noScroll");
    document.querySelector('#miniCart').classList.remove("active");
    document.querySelector("#miniCartEmpty").classList.remove("active");
    document.querySelector("#miniCartContent").classList.remove("active");
    document.querySelector("#miniCart").close();
}

// manual discount code add
if (document.querySelector('#miniCartFooterDiscount')) {
    // Remove loading and reset discount UI
    const discountWrap = document.querySelector('#miniCartFooterDiscountCodeWrap');
    const discountButton = document.querySelector('#miniCartFooterDiscountFieldButton');
    const discountInvalid = document.querySelector('#miniCartFooterDiscountInvalid');

    document.querySelector('#miniCartFooterDiscountField').addEventListener("submit", async function (e) {
        // prevent default form submission
        e.preventDefault();

        // get the user input value
        const inputValue = this.querySelector('#miniCartFooterDiscountFieldInput').value;
        if (inputValue) {
            // add loading to cart
            document.querySelector('#miniCartContentWrapper').classList.add("loading");

            let discounts = ""

            // check if the cart already has the code applied
            if (cart.discount_codes?.find(code => code.code.toLowerCase() === inputValue.toLowerCase() && code.applicable === true)) {
                // remove loading from cart
                document.querySelector('#miniCartContentWrapper').classList.remove("loading");

                // show the error message
                discountInvalid.innerHTML = "This code has already been applied.";
                discountInvalid.classList.add("active");
                return;
            }

            // remove any existing discount code from the cart before applying the new one to prevent multiple codes being applied
            await updateCart({discount: ""});

            try {
                cart = await updateCart({discount: inputValue});

                // fetch the cart again to get the updated discount codes
                await openCart();

                // loop through discount codes and check if applicable
                cart.discount_codes.forEach((item) => {
                    if (item.applicable === true) {
                        discounts += `${item.code},`
                    }
                })

                // if no applicable codes, show code is not valid and exit
                if (!discounts) {
                    // remove loading from cart
                    document.querySelector('#miniCartContentWrapper').classList.remove("loading");

                    // in case the text is 'applied' from a previous code, remove it                    document.querySelector('#miniCartFooterDiscountCodeWrap').classList.remove('active');
                    discountButton.innerHTML = "Apply";
                    discountButton.classList.remove("unclickable");

                    // remove valid class from field
                    this.classList.remove("validCode");

                    // remove discount code from footer if it's showing
                    discountWrap.classList.remove('active');

                    // show the error message
                    discountInvalid.innerHTML = "This code is not valid.";
                    discountInvalid.classList.add("active");
                    return;
                }

                // remove loading from cart
                document.querySelector('#miniCartContentWrapper').classList.remove("loading");

                // hide the error message if it's showing
                discountInvalid.classList.remove("active");

                // reset the discount wrap in case there was a previous code applied
                discountWrap.innerHTML = "";

                // if successful, add the applied code to the mini cart footer and show it if it's not already showing
                discountWrap.insertAdjacentHTML('beforeend', `
                   <div class="miniCartFooterDiscountCode">
                        <span class="miniCartFooterDiscountCodeTitle">${inputValue} discount</span>
                        <span class="miniCartFooterDiscountCodePrice">-${price(cart.original_total_price - cart.total_price)}</span>
                    </div>`
                )
                // show the discount code in the footer
                discountWrap.classList.add('active');

                // if the discount code applied successfully, add validCode class to the input field to show it's valid
                this.classList.add("validCode");

                // change the button text to 'applied'
                discountButton.innerHTML = "Applied";
                // make the button not clickable since the code is already applied
                discountButton.classList.add("unclickable");

            } catch (error) {
                console.error(error)
            }
        }
    })

    // add event listener to the discount code input field to remove the discount code if the user edits the code after applying it
    document.querySelector('#miniCartFooterDiscountFieldInput').addEventListener("input", async function () {
        // if the field has the validCode class, that means a code has been applied and the user is now editing it, we should make the button clickable again
        if (this.closest('#miniCartFooterDiscountField').classList.contains("validCode")) {
            let button = this.closest('#miniCartFooterDiscountField').querySelector('#miniCartFooterDiscountFieldButton');
            // update the text back to apply
            button.innerHTML = "Apply";
            // make clickable again
            button.classList.remove("unclickable");
        }
    })
}

// clean up discount code on cart update (if the code is no longer valid, etc.)
function cleanUpDiscountCode() {
    const discountWrap = document.querySelector('#miniCartFooterDiscountCodeWrap');
    const discountButton = document.querySelector('#miniCartFooterDiscountFieldButton');
    const discountInvalid = document.querySelector('#miniCartFooterDiscountInvalid');


    // in case the text is 'applied' from a previous code, remove it
    discountWrap.classList.remove('active');
    discountWrap.innerHTML = "";
    discountButton.innerHTML = "Apply";
    discountButton.classList.remove("unclickable");

    // remove valid class from field
    document.querySelector('#miniCartFooterDiscountField').classList.remove("validCode");

    // hide the error message if it's showing
    discountInvalid.classList.remove("active");
}

// update the discount text if no items have their dropdowns open
function updateDiscountText() {

    // check if there are any subscription items
    let numSubs = 0
    cart.items.forEach((item) => {
        if (item.selling_plan_allocation) {
            numSubs++;
        }
    })

    // No subs? Remove and exit.
    if (numSubs === 0) {
        document.querySelector('#miniCartFooterCode').classList.remove('active');
        return;
    }

    // declare total price variable
    let totalPrice = 0;

    // get the cart price after the 20% subscription discount
    cart.items.forEach((item) => {
        if (item.selling_plan_allocation) {
            totalPrice = price(((item.final_line_price * 0.2)), true);
        }
    })

    // get the discount element
    let discount = document.querySelector('#miniCartFooterCode');
    document.querySelector('#miniCartFooterCode').classList.add('active');

    // update the text
    discount.innerHTML = `Use code: <u class="bold">Welcome20</u> at checkout for an additional <u class="bold">${totalPrice}</u> off your first order`;
}

//close cart event listener
document.querySelectorAll(".closeCart").forEach(function (element) {
    element.addEventListener("click", closeCart);
});
document.querySelector("#miniCart").addEventListener("click", function (e) {
    if (e.target === this) {
        closeCart();
    }
})

// populate the upsell products if needed
const upsellContainer = document.querySelector("#miniCartUpsellsContainer");

function updateUpsells() {
    // check which product handles are in the cart
    let handlesInCart = [];
    cart.items.forEach(item => {
        if (!handlesInCart.includes(item.handle)) {
            handlesInCart.push(item.handle);
        }
    })

    // create variables to determine if we'll be showing rolls and tissues upsells
    let showRolls = true;
    let showTissues = true;
    let numTissues = 8;
    let specialTitle = null;
    let handles = Object.keys(handleToVariantID);

    // determine if this is the USA or CA store and adjust the handles accordingly
    if (isCanada === true) {
        // keep only handles with the CA identifier
        handles = handles.filter(key => key.toString().includes('-ca'));
    } else {
        // remove any handles with the CA identifier
        handles = handles.filter(key => !key.toString().includes('-ca'));
    }

    // compare the handles in cart to the handles we have
    handlesInCart.forEach(item => {
        // check if we can show rolls upsell
        if (handles.includes(item) && item.toString().includes('rolls')) {
            showRolls = false;
        }
        // check if we show tissues upsell
        if (handles.includes(item) && item.toString().includes('boxes')) {
            showTissues = false;
        }
    })

    // reset the container
    upsellContainer.innerHTML = "";

    // show rolls upsell
    if (showRolls) {
        createUpsellHTML(
            {
                type: "rolls",
                title: "PlantPaper",
                atcTitle: "Add PlantPaper",
                bullets: [
                    "Tree-free, toxin-free toilet paper",
                    "Made of soft, strong,",
                    "3 ply, FSC-certified bamboo"
                ],
                image: "https://cdn.shopify.com/s/files/1/0247/1202/0052/files/DSCF6444_115.png?v=1768488673"
            }
            , upsellContainer);
    }

    // show tissues upsell
    if (showTissues) {
        let matrixEntry = upsellMatrix[handlesInCart.find(item => item.includes('rolls'))];
        // if matrix entry
        if (matrixEntry) {
            let handleName = matrixEntry.handle;

            // determine the number of tissues to show in the upsell
            if (handleName.includes('rolls-')) {
                let separator = 'rolls-';
                if (handleName.indexOf(separator) !== -1) {
                    handleName = handleName.slice(handleName.indexOf(separator) + separator.length);
                }
            }
            // get the number of tissues from the handle
            numTissues = handleName.match(/\d+/g);

            // if this is a replace in cart upsell, change the title to reflect the number of tissues in the pack
            if (matrixEntry.replace_in_cart === false) {
                specialTitle = "Add Facial Tissue " + numTissues + " boxes";
            }
        }

        let upsellItem = variantIDToProduct[handleToVariantID[matrixEntry.handle]];
        let triggerItem = cart.items.find(item => item.handle === handlesInCart.find(item => item.includes('rolls')));

        createUpsellHTML(
            {
                type: "tissues",
                title: "Tissue",
                atcTitle: specialTitle != null ? specialTitle : "Bundle Facial Tissue",
                originalProd: triggerItem,
                upsellProd: upsellItem,
                bullets: [
                    `${numTissues} boxes, 60 tissues per box`,
                    "100% non-toxic, 3 ply",
                    "Soft, strong, bleach-free bamboo"
                ],
                image: "https://cdn.shopify.com/s/files/1/0247/1202/0052/files/PlantPaper-Tissue-1_75.png?v=1771361139"
            }
            , upsellContainer);
    }

    // if we don't have any upsells to show, hide container
    if (document.querySelectorAll('.miniCartUpsellsContainerItem').length === 0) {
        document.querySelector('#miniCartUpsells').classList.remove('active');
    } else {
        document.querySelector('#miniCartUpsells').classList.add('active');
    }
}

// helper function to add upsells to parent container
function createUpsellHTML(itemInfo, parent) {
    // destructure item info
    let type = itemInfo.type;
    let title = itemInfo.title;
    let bullets = itemInfo.bullets;
    let image = itemInfo.image;
    let atcTitle = itemInfo.atcTitle;
    let upsell = itemInfo?.upsellProd;
    let trigger = itemInfo?.originalProd;

    function atcPricing() {

        // if it's not a tissues upsell or if it is but it's a replace in cart upsell, do not proceed
        if (type !== "tissues") {
            return "";
        }

        let compare = "";
        let real = "";

        // check if we're replacing the item in cart
        if (upsellMatrix[trigger?.handle].replace_in_cart === true) {
            if (trigger.selling_plan_allocation) {
                real = (upsell.variants[0].selling_plan_allocations[0].per_delivery_price - trigger.selling_plan_allocation.per_delivery_price)
            } else {
                real = (upsell.variants[0].price - trigger.price);
            }
        }
        // if we're not replacing the item in cart
        else {
            if (trigger.selling_plan_allocation) {
                real = upsell.variants[0].selling_plan_allocations[0].price;
            } else {
                real = upsell.variants[0].price;
            }
        }

        // check if we have special bundle pricing for this upsell
        if (bundlePricing[upsell.handle]) {
            compare = bundlePricing[upsell.handle] * 100;
        }
        // otherwise, check if the discount from the subscription is greater than the discount from just the price difference, and if so, apply the subscription discount language to the price
        else if (upsellMatrix[trigger?.handle].replace_in_cart === true && ((upsell.variants[0].price - trigger.price) - Math.ceil(real)) > 0) {
            compare = (upsell.variants[0].price - trigger.price);
        } else if (upsellMatrix[trigger?.handle].replace_in_cart === false && (upsell.variants[0].price - Math.ceil(real)) > 0) {
            compare = upsell.variants[0].price;
        }

        // update HTML
        let html = "";
        if (compare) {
            html += `<span class="miniCartUpsellsContainerItemATCCompare">+${price(compare)}</span>`;
        }
        html += `<span class="miniCartUpsellsContainerItemATCPrice">+${price(real)}</span>`;
        return html;

    }

    // create upsell element
    parent.insertAdjacentHTML('beforeend', `
        <div class="miniCartUpsellsContainerItem ${type}">
            <div class="miniCartUpsellsContainerItemWrapper">
                <img class="miniCartUpsellsContainerItemImg" src="${image}">
                <div class="miniCartUpsellsContainerItemContent">
                    <div class="miniCartUpsellsContainerItemTop">
                        <div class="miniCartUpsellsContainerItemTopText">
                            <div class="miniCartUpsellsContainerItemTopTextTitle">
                                ${title}
                            </div>
                            <div class="miniCartUpsellsContainerItemTopStars">
                            <svg width="57" height="12" viewBox="0 0 57 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.75757 0L7.05022 3.97838L11.2333 3.97838L7.84912 6.43715L9.14178 10.4155L5.75757 7.95676L2.37335 10.4155L3.66601 6.43715L0.281796 3.97838L4.46491 3.97838L5.75757 0Z" fill="#153BFE"/>
                                <path d="M17.2732 0L18.5658 3.97838L22.749 3.97838L19.3647 6.43715L20.6574 10.4155L17.2732 7.95676L13.889 10.4155L15.1816 6.43715L11.7974 3.97838L15.9805 3.97838L17.2732 0Z" fill="#153BFE"/>
                                <path d="M28.7888 0L30.0815 3.97838L34.2646 3.97838L30.8804 6.43715L32.173 10.4155L28.7888 7.95676L25.4046 10.4155L26.6973 6.43715L23.313 3.97838L27.4962 3.97838L28.7888 0Z" fill="#153BFE"/>
                                <path d="M39.7263 0L41.019 3.97838L45.2021 3.97838L41.8179 6.43715L43.1105 10.4155L39.7263 7.95676L36.3421 10.4155L37.6348 6.43715L34.2505 3.97838L38.4337 3.97838L39.7263 0Z" fill="#153BFE"/>
                                <path d="M51.2419 0L52.5346 3.97838L56.7177 3.97838L53.3335 6.43715L54.6262 10.4155L51.2419 7.95676L47.8577 10.4155L49.1504 6.43715L45.7662 3.97838L49.9493 3.97838L51.2419 0Z" fill="#153BFE"/>
                            </svg>
                            <span class="miniCartUpsellsContainerItemTopStarsText">
                                5.2K 5-star reviews
                            </span>
                        </div>
                        </div>
                    </div>
                    <div class="miniCartUpsellsContainerItemMiddle">
                        <div class="miniCartUpsellsContainerItemMiddleBullets">
                                    ${bullets.map(bullet => `<span>${bullet}</span><br>`).join('')}
                        </div>
                    </div>
                </div>
            </div>
            <div class="miniCartUpsellsContainerItemATCWrapper">
                <button class="miniCartUpsellsContainerItemATC">
                    + ${atcTitle}
                </button>
                ${atcPricing()}
            </div>
        </div>
        `)
}

// event delegation for upsell clicks since they are dynamically added
document.querySelector('#miniCartUpsellsContainer').addEventListener('click', async function (e) {
    let targetEl = e.target.closest('.miniCartUpsellsContainerItem')
    let selectRangeEl = e.target.closest('.miniCartUpsellsContainerItemATCSelectRange');

    // if the click is on the select range, we don't want to trigger the add to cart function
    if (selectRangeEl) {
        return;
    }
    if (targetEl) {
        await addUpsells(targetEl);
    }
})

// add upsells on click
async function addUpsells(el) {
    // add loading to cart
    document.querySelector('#miniCartContentWrapper').classList.add("loading");

    // determine which upsell was clicked
    const isRolls = el.classList.contains('rolls');
    const isTissues = el.classList.contains('tissues');

    // check which items are in the cart
    let itemsInCart = [];
    cart.items.forEach(item => {
        if (!itemsInCart.includes(variantIDToProduct[item.variant_id].handle)) {
            itemsInCart.push(
                {handle: variantIDToProduct[item.variant_id].handle, key: item.key}
            )
        }
    })

    // item handle we need to find the matrix entry for
    let itemHandle;

    // we may need the key of the item in the cart
    // to remove if the upsell replaces in cart
    let itemKey;

    // find the first item in the cart with rolls in the handle and get its handle and key for later
    if (isRolls) {
        itemHandle = (itemsInCart.find(item => item.handle.toString().includes('boxes'))).handle;
        itemKey = (itemsInCart.find(item => item.handle.toString().includes('boxes'))).key;
    }
    // find the first item in the cart with boxes in the handle and get its handle and key for later
    else if (isTissues) {
        itemHandle = (itemsInCart.find(item => item.handle.toString().includes('rolls'))).handle;
        itemKey = (itemsInCart.find(item => item.handle.toString().includes('rolls'))).key;
    } else {
        return;
    }

    // matrix entry for the item in the cart
    let matrixEntry = variantIDToProduct[handleToVariantID[upsellMatrix[itemHandle]?.handle]];

    // if there's no matrix entry for this item, just pull the first relevant upsell
    if (!upsellMatrix[itemHandle]) {
        if (isRolls) {
            matrixEntry = variantIDToProduct[handleToVariantID[Object.keys(upsellMatrix).find(key => upsellMatrix[key].handle.includes('rolls'))]];
        } else if (isTissues) {
            matrixEntry = variantIDToProduct[handleToVariantID[Object.keys(upsellMatrix).find(key => upsellMatrix[key].handle.includes('boxes'))]];
        }
    }

    // once we have an entry, add the upsell to the cart
    if (matrixEntry) {
        // check if the original item had a subscription

        let hadSub = false;
        let attachedSub = null;
        const subItem = cart.items.find(item => item.selling_plan_allocation);

        // try to add subscription if the original item had one
        if (subItem) {
            hadSub = true;
            let originalPlan = subItem.selling_plan_allocation.selling_plan?.name;
            let plans = flattenSellingPlans(variantIDToProduct[matrixEntry.variants[0].id]);

            // has more than one selling plan? try to find the needed one
            if (plans.length > 1 && plans[0].name !== originalPlan) {
                // see if it has a default cadence we can match to
                if (defaultCadenceMatrix[matrixEntry.handle]) {
                    let defaultPlan = defaultCadenceMatrix[matrixEntry.handle];
                    for (const plan of plans) {
                        if (plan.name.includes(defaultPlan)) {
                            attachedSub = plan.id;
                            break;
                        }
                    }
                }
                // if no default, try to match to the triggering item's cadence
                else {
                    for (const plan of plans) {
                        if (plan.name === originalPlan) {
                            attachedSub = plan.id;
                            break;
                        }
                    }
                }
            } else {
                // in case it can't find the default or same cadence, just use its first plan
                attachedSub = plans[0].id;
            }
        }

        // find the item in the cart
        const cartItem = cart.items.find(item => item.key === itemKey);

        // check if the upsell replaces in cart, if so remove the original item from the cart first
        if (upsellMatrix[itemHandle] && upsellMatrix[itemHandle]?.replace_in_cart === true) {
            if (cartItem) {
                // remove the item from the cart
                await changeProduct({
                    id: cartItem.key,
                    quantity: 0,
                });
            }
        }
        // add the upsell to the cart
        await addProduct({
            items: [{
                quantity: cartItem ? cartItem.quantity : 1,
                id: matrixEntry.variants[0].id,
                selling_plan: hadSub && attachedSub != null ? attachedSub : null,
            }]
        });
    }

    // remove loading
    document.querySelector('#miniCartContentWrapper').classList.remove("loading");

    // refresh cart
    await openCart();

}

// add to cart button
document.querySelector('#miniCartFooterCheckout')?.addEventListener("click", async function () {
    // add loading
    this.classList.add("loading");

    // proceed to checkout
    this.classList.remove("loading");
    window.location.href = "/checkout";

})

// open cart
document.querySelectorAll('.toggleCart').forEach((item) => {
    item.addEventListener('click', async function () {
        await openCart(true);
    })
})